import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { Observable, of } from "rxjs";
import { SelectList } from "../shared/models/select-list";
import { Helper } from "../shared/utils/helper";
import { PickAddress, PickAddressFilter } from "../components/company/company";

@Injectable({
  providedIn: "root",
})
export class LookupService {
  private baseUrl = `${environment.baseUrl}`;

  constructor(private http: HttpClient) {}

  getDefaultAddress() {
    return this.http.get(`${this.baseUrl}/addressbook/view/default`);
  }

  getPickupAddress(data: PickAddressFilter): Observable<PickAddress[]> {
    const params = this._extraxtPickAddressFilter(data);
    return this.http
      .get(`${this.baseUrl}/business/contact/list`, { params: params })
      .pipe(map((resp: any) => resp.result.items));
  }
  private _extraxtPickAddressFilter(data: PickAddressFilter): HttpParams {
    let params = new HttpParams()
      .set("BusinessId", data.BusinessId)
      .set("ContactType", data.ContactType)
      .set("Page", data.Page + "");
    return params;
  }

  countryList() {
    return this.http
      .get(`${this.baseUrl}/country/list`)
      .pipe(map((res: any) => res.result));
  }

  getStateList(country: string): Observable<Array<SelectList>> {
    const params = new HttpParams().set("country", country);
    return this.http
      .get<{ result: Array<SelectList> }>(
        `${this.baseUrl}/country/state/selectlist`,
        { params }
      )
      .pipe(map((m) => m.result));
  }
  getCityList(country: string, state: string): Observable<Array<SelectList>> {
    const params = new HttpParams().set("country", country).set("state", state);
    return this.http
      .get<{ result: Array<SelectList> }>(
        `${this.baseUrl}/country/state/city/selectlist`,
        { params }
      )
      .pipe(map((m) => m.result));
  }

  getAddressByPostcode(postcode, country) {
    const params = new HttpParams()
      .set("country", country)
      .set("postcode", postcode);
    return this.http.get(`${this.baseUrl}/postcode/view/bypostcode`, {
      params: params,
    });
  }

  listCustomer(id) {
    if (Helper.isEmpty(id)) {
      return;
    }
    return this.http.get(`${this.baseUrl}/business/selectlist/customer/${id}`);
  }

  listCurrency() {
    return this.http.get(`${this.baseUrl}/country/selectlist/currency`);
  }

  getPrentCompanyList() {
    return this.http.get(
      `${this.baseUrl}/business/selectlist/allowed?includeSelf=true`
    );
  }
  getBusinessTypeList() {
    return this.http.get(`${this.baseUrl}/business/selectlist/types`);
  }
  getWeightLogicList() {
    return this.http.get(`${this.baseUrl}/weightlogic/selectlist/all`);
  }
  getstandardrateLisrt() {
    return this.http.get(`${this.baseUrl}/quotation/selectlist/standardrate`);
  }
  getQuotationByTypeLisrt(quotationtype: string = "StandardRate") {
    return this.http.get(`${this.baseUrl}/quotation/selectlist/quotationtype`);
  }
  getDedicatedPUList() {
    return this.http.get(`${this.baseUrl}/station/selectlist/all`);
  }
  getBusinessStatusList() {
    return this.http.get(`${this.baseUrl}/business/selectlist/statuses`);
  }
  getResaleAgentList() {
    return this.http.get(`${this.baseUrl}/user/selectlist/salesmen`);
  }
  getBillingBusinessList(parentId) {
    return this.http.get(
      `${this.baseUrl}/business/selectlist/billings/${parentId}`
    );
  }

  getProductList() {
    return this.http
      .get(`${this.baseUrl}/product/list`)
      .pipe(map((res: any) => res.result));
  }
  getProductListByBusinessId(businessId) {
    const params = new HttpParams().set("BusinessId", businessId);
    return this.http
      .get(`${this.baseUrl}/product/list/${businessId}`)
      .pipe(map((res: any) => res.result));
  }

  getPackageTypeList(): Observable<SelectList[]> {
    return this.http.get<SelectList[]>(
      `${this.baseUrl}/packagetype/selectlist`
    );
  }
  internalBusinessbyTypesRequest(): Observable<Array<SelectList>> {
    return this.http
      .get<{ result: Array<SelectList> }>(
        `${this.baseUrl}/v1/business/selectlist/allowed?businessType=internal`
      )
      .pipe(map((m) => m.result));
  }

  internalBusinessRequest(): Observable<Array<SelectList>> {
    return this.http
      .get<{ result: Array<SelectList> }>(
        `${this.baseUrl}/v1/business/selectlist/allowed`
      )
      .pipe(map((m) => m.result));
  }

  getCarrencyList(): Observable<SelectList[]> {
    return this.http
      .get<{ result: SelectList[] }>(
        `${this.baseUrl}/country/selectlist/currency`
      )
      .pipe(map((m) => m.result));
  }
  getUOMList(): Observable<SelectList[]> {
    return this.http.get<SelectList[]>(`${this.baseUrl}/uom/selectlist`);
  }
  get_BusinessAllowedSelectList(): Observable<SelectList[]> {
    return this.http.get<SelectList[]>(
      `${this.baseUrl}/business/selectlist/allowed`
    );
  }
  get_UserTypeSelectList(): Observable<SelectList[]> {
    return this.http.get<SelectList[]>(`${this.baseUrl}/user/selectlist/types`);
  }
  get_UserStatusSelectList(): Observable<SelectList[]> {
    return this.http.get<SelectList[]>(
      `${this.baseUrl}/user/selectlist/statuses`
    );
  }
  get_DepartmentSelectList(): Observable<SelectList[]> {
    return this.http.get<SelectList[]>(
      `${this.baseUrl}/organizationunit/selectlist`
    );
  }
  get_StationByBusinessIdSelectList(businessId): Observable<SelectList[]> {
    return this.http.get<{result:SelectList[]}>(
      `${this.baseUrl}/station/selectlist/bybusiness/${businessId}`
    ).pipe(map((m)=>m.result));
  }

  getStatus(): Observable<SelectList[]> {
    return this.http.get<{result: SelectList[]}>(`${this.baseUrl}/job/selectlist/statuses`).pipe(map((m)=>m.result));
  }

  get_MainfestStatusSelectList(): Observable<SelectList[]> {
    return this.http.get<SelectList[]>(
      `${this.baseUrl}/manifest/selectlist/statuses`
    );
  }
  get_MainfestTypeSelectList(): Observable<SelectList[]> {
    return this.http.get<SelectList[]>(
      `${this.baseUrl}/manifest/selectlist/types`
    );
  }
  post_podImg(data) {
    return this.http.post(`${this.baseUrl}/uploader/file`, data);
  }

  get_malaysiaLocalTime(): Observable<any> {
    return this.http.get(
      "https://worldtimeapi.org/api/timezone/Asia/Singapore"
    );
  }

  get_countries(): Observable<SelectList[]> {
    return this.http.get<{result: SelectList[]}>(`${this.baseUrl}/country/selectlist`).pipe(map((m)=>m.result));
  }

  get_businessAllowedIsLastMile (customerId): Observable<SelectList[]> {
    if (customerId==null) {
      return of([]);
    }
    const params = new HttpParams()
    .set("useIsLastMile", Helper.getUserObject('IsLastMile'))
    .set("businessId", customerId)
    return this.http.get<{result: SelectList[]}>(`${this.baseUrl}/business/selectlist/allowed`, {params: params}).pipe(map((m)=>m.result));
  }

  get_paymentType():Observable<Array<SelectList>>{
    return this.http.get<{result: Array<SelectList>}>(`${this.baseUrl}/invoice/selectlist/paymenttypes`)
    .pipe(
        map((m)=>m.result)
    )
  };

  get_invoiceStatuses():Observable<Array<SelectList>>{
    return this.http.get<{result: Array<SelectList>}>(`${this.baseUrl}/invoice/selectlist/statuses`)
    .pipe(
        map((m)=>m.result)
    )
  };

  get_internalBusiness():Observable<Array<SelectList>>{
    return this.http.get<{result: Array<SelectList>}>(`${this.baseUrl}/business/selectlist/internal`)
    .pipe(
        map((m)=>m.result)
    )
  };

  get_allowedBusinessLastMile():Observable<Array<SelectList>>{
    const params = new HttpParams().set("useIsLastMile", "false");
    return this.http.get<{result: Array<SelectList>}>(`${this.baseUrl}/business/selectlist/allowed`, {params})
    .pipe(
        map((m)=>m.result)
    )
  };
}
